import GlitchText from './GlitchText';
import './Logo.css';

/* ============================================================================
   Logo — the DECRYPEDIA wordmark.

   The two-tone split (paper over red, sliced diagonally) mirrors the project's
   key art. It's a clip-path duplicate of the same text rather than an image so
   it stays crisp at any size and inherits the glitch treatment.

   size: sm | md | lg
   ========================================================================== */

function Logo({ size = 'md', className = '', ...rest }) {
  return (
    <div className={`ui-logo ui-logo--${size} ${className}`} {...rest}>
      <GlitchText as="span" className="ui-logo__text" intensity="extreme">
        DECRYPEDIA
      </GlitchText>
      {/* Red lower half, clipped diagonally across the letterforms. */}
      <span className="ui-logo__slice" aria-hidden="true">
        DECRYPEDIA
      </span>
    </div>
  );
}

export default Logo;
